import {
  container,
  defaultFont,
  title
} from "assets/jss/material-kit-react.jsx";

const landingPageStyle = {
  container: {
    zIndex: "12",
    color: "#3C4858",
    ...container
  },
  title: {
    ...title,
    display: "inline-block",
    position: "relative",
    marginTop: "30px",
    minHeight: "32px",
    maxHeight: "300px",
    color: "#FFFFFF",
    textDecoration: "none"
  },
  buttonLink: {
    position: "relative",
    textDecoration: "none",
    color: "inherit",
    display: "inline-flex",
    "&:hover,&:focus": {
      color: "inherit",
      background: "transparent"
    }
  },
  subtitle: {
    fontSize: "1.313rem",
    maxWidth: "600px",
    margin: "10px 0 0",
    color: "#FFFFFF"
  },
  main: {
    background: "#FFFFFF",
    position: "relative",
    zIndex: "3"
  },
  mainRaised: {
    margin: "-60px 30px 0px",
    borderRadius: "6px",
    boxShadow:
      "0 16px 24px 2px rgba(0, 0, 0, 0.14), 0 6px 30px 5px rgba(0, 0, 0, 0.12), 0 8px 10px -5px rgba(0, 0, 0, 0.2)"
  }
};

export default landingPageStyle;
